import { createSelector } from 'reselect';
import { RootState } from 'src/app/store';
import { ExceptionsListState } from './exceptionsListStore';

const getState = (state: RootState): ExceptionsListState => state.exceptionsList;

export const getExceptionMarkedToRemove = createSelector(
  getState,
  state => state.exceptionMarkedToRemove,
);
